import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=35d77414&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"
import style0 from "./CustomersPage.vue?vue&type=style&index=0&id=35d77414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d77414",
  null
  
)

export default component.exports